import { createRouter,createWebHashHistory } from "vue-router";
import Home from '../pages/home.vue'
import Summary from '../components/mobilephone/summary.vue'
const routes = [

    {
      path:'/home',
      name:Home,
      component:Home
    },
    {
      path:'/summary',
      name:Summary,
      component:Summary
    },
    {
      path:'/mainbusiness',
      name:'mainbusiness',
      component:() => import('@/components/mobilephone/mainbusiness.vue'),
    },
    {
      path:'/main_one',
      name:'main_one',
      component:() => import('@/components/mobilephone/main_one.vue'),
    },
    {
      path:'/main_two',
      name:'main_two',

      component:() => import('@/components/mobilephone/main_two.vue'),
    },
    {
      path:'/main_three',
      name:'main_three',

      component:() => import('@/components/mobilephone/main_three.vue'),
    },
    {
      path:'/ClassicCases',
      name:'ClassicCases',

      component:() => import('@/components/mobilephone/ClassicCases.vue'),
    },
    {
      path:'/Classic_one',
      name:'Classic_one',

      component:() => import('@/components/mobilephone/Classic_one.vue'),
    },
    {
      path:'/Classic_two',
      name:'Classic_two',

      component:() => import('@/components/mobilephone/Classic_two.vue'),
    },
    {
      path:'/VrGis',
      name:'VrGis',

      component:() => import('@/components/mobilephone/VrGis.vue'),
    },
    {
      path:'/content',
      name:'content',

      component:() => import('@/components/mobilephone/content.vue'),
    },
    {
      path:'/Partners',
      name:'Partners',

      component:() => import('@/components/mobilephone/Partners.vue'),
    },
    {
      path:'/text',
      name:'text',
      component: () => import('@/components/text.vue'),
    },
    {
      path:'/contactus',
      name:'contactus',
      component:() => import('@/components/computer/contactus.vue'),
    },{
      path:'/Journalism',
      name:'Journalism',
      component:() => import('@/components/computer/Journalism.vue'),
    },
    {
      path:'/helloworld',
      name:'helloworld',
      component:() => import('@/components/HelloWorld.vue'),
    },
    {
        path:'/',
        redirect:'/home',
        component:Home
    },
    
  ]
  const router = createRouter({
    history:createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      // 始终滚动到顶部
      return { top: 0 };
    },
  })
  
  export default router
  